module.exports = __webpack_public_path__ + "static/media/hostigamiento.98b6209c.png";